import { render } from "./SystemLogsSchedules.vue?vue&type=template&id=b5bfbe32&scoped=true"
import script from "./SystemLogsSchedules.vue?vue&type=script&lang=js"
export * from "./SystemLogsSchedules.vue?vue&type=script&lang=js"

import "./SystemLogsSchedules.vue?vue&type=style&index=0&id=b5bfbe32&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5bfbe32"]])

export default __exports__